import React from "react";
import { Typography } from "@mui/material";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import TimerComponent from "../../../components/TimerComponent";

function ExamHeader({
  subjectName,
  setIsTimeUp,
  showSubmitModal,
  handleCloseSubmitModal,
  handleFinalSubmit,
  handleFinalSubmitCheck,
  isTimeUp,
  stats,
  submitError,
  countdownTime,
  finalSubmitChecked,
}) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "5px 10px",
        borderBottom: "1px solid black",
        backgroundColor: "#e3f2fd", // light blue shade
      }}
    >
      <div>
        <Typography fontWeight="bold">{subjectName}</Typography>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: "7px",
        }}
      >
        <AccessTimeOutlinedIcon style={{ fontSize: 20 }} />
        <Typography>
          <TimerComponent
            setIsTimeUp={setIsTimeUp}
            showSubmitModal={showSubmitModal}
            handleCloseSubmitModal={handleCloseSubmitModal}
            handleFinalSubmit={handleFinalSubmit}
            isFormatTime={true}
            isTimeUp={isTimeUp}
            stats={stats}
            submitError={submitError}
            countdownTime={countdownTime}
            finalSubmitChecked={finalSubmitChecked}
            handleFinalSubmitCheck={handleFinalSubmitCheck}
          />
        </Typography>
      </div>
    </div>
  );
}

export default ExamHeader;
